export default __webpack_public_path__ + "static/avatar-kayi-sketch-0-detail-5e587a8da8ce93c23d88a650c168a7c7.png";